/**
 * Returns a new array with the elements randomly reordered (Fisher-Yates).
 * The input array is not mutated.
 * @template T
 * @param {T[]} array
 * @return {T[]}
 */
export function shuffle(array) {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
}
